import { Api } from "./api"

export class ShareSampleApi extends Api {
  constructor() {
    super('share_samples', [])
  }
}
